import {
  Box,
  Heading,
  SimpleGrid,
  Text,
  Badge,
} from "@chakra-ui/react";
import { useState } from "react";
import { paymentMethods } from "components/BalanceTopUp/paymentMethods";

interface InvoicePaymentSelectorProps {
  onSelect: (currency: string, network: string) => void;
}

const InvoicePaymentSelector = ({ onSelect }: InvoicePaymentSelectorProps) => {
  const [selectedMethod, setSelectedMethod] = useState<number | null>(null);
  
  const handleMethodClick = (methodId: number) => {
    const method = paymentMethods.find((m) => m.id === methodId);
    if (method) {
      setSelectedMethod(methodId);
      onSelect(method.abbr, method.network);
    }
  };

  return (
    <Box>
      <Heading size="md" mb={3} textAlign="center" color="text.primary">
        Select Payment Method
      </Heading>
      <Text textAlign="center" color="text.secondary" mb={6} fontSize="sm">
        Cryptocurrency will be used for the invoice. Select one option.
      </Text>

      <SimpleGrid columns={[1, 2, 3]} spacing={4}>
        {paymentMethods.map((method) => {
          const isSelected = selectedMethod === method.id;

          return (
            <Box
              key={method.id}
              cursor="pointer"
              onClick={() => handleMethodClick(method.id)}
              transition="all 0.18s ease-out"
              borderRadius="xl"
              borderColor={isSelected ? "brand.accent" : "border.strong"}
              borderWidth={isSelected ? "2px" : "1px"}
              bg={isSelected ? "brand.subtle" : "bg.surface"}
              boxShadow={isSelected ? "lg" : "sm"}
              _hover={{
                boxShadow: "lg",
                transform: "translateY(-2px)",
                bg: isSelected ? "brand.subtle" : "bg.surfaceHover",
                borderColor: "brand.accent",
              }}
              _active={{
                transform: "translateY(0)",
                boxShadow: "md",
              }}
              p={4}
              display="flex"
              flexDirection="column"
              alignItems="center"
            >
              <Box
                mb={3}
                display="flex"
                justifyContent="center"
                alignItems="center"
                borderRadius="full"
                bg="neutral.100"
                boxSize="52px"
              >
                {method.image}
              </Box>

              <Text fontWeight="bold" fontSize="sm" textAlign="center" color="text.primary">
                {method.name}
              </Text>

              <Badge
                mt={2}
                variant="subtle"
                colorScheme="blue"
                fontSize="0.7rem"
                px={2}
                borderRadius="full"
                fontWeight="medium"
              >
                {method.abbr} · {method.network}
              </Badge>
            </Box>
          );
        })}
      </SimpleGrid>
    </Box>
  );
};

export default InvoicePaymentSelector;
